// extracted by mini-css-extract-plugin
export var backButton = "_1c-1";
export var content = "_1c-d";
export var continueButton = "_1c-7";
export var continueHint = "_1c-8";
export var continueRow = "_1c-6";
export var leftInner = "_1c-0";
export var shell = "_1c-e";
export var sidebarContent = "_1c-5";
export var skipButton = "_1c-c";
export var spacer = "_1c-2";
export var spin = "_1c-a";
export var spinner = "_1c-9";
export var spinnerOverlay = "_1c-b";
export var subtitle = "_1c-4";
export var title = "_1c-3";